import { _Config } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
export const useDecoratedRoute = (decoratorTheme, route) => {
    const [configM] = useGlobalState(_Config);
    const decoratorPrefixMapM = M.chain((x) => x.decoratorPrefixMap, configM);
    const decoratorPrefixMap = M.fromMaybe(decoratorPrefixMapM, {
        kids: M.of(""),
        teens: M.of(""),
        default: M.of(""),
        mindblown: M.of(""),
    });
    const getRoute = () => {
        let decoratedRoute = "";
        Object.entries(decoratorPrefixMap).forEach(([key, value]) => {
            switch (decoratorTheme) {
                case key:
                    decoratedRoute = M.fromMaybe(value, "") + route;
                    break;
                default:
                    break;
            }
        });
        return decoratedRoute ? decoratedRoute : route;
    };
    const decoratedRoute = getRoute();
    return { decoratedRoute };
};

